<template>
  <div class="app defaultContainer-component">
    <div class="menu-responsive d-sm-block d-md-none">
      <v-app-bar app fixed :class="drawer ? 'header-right' : ''">
        <v-app-bar-nav-icon class="menu-button" @click.stop="drawer = !drawer">
        </v-app-bar-nav-icon>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" absolute right temporary>
        <v-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <div class="logo-image-navbar">
            <img src="../assets/images/logoname.png" />
          </div>
        </v-col>
        <div class="menu-box ps-2 pe-2 mt-3">
          <div
            class="menu-items pa-0"
            v-for="(item, index) in nav"
            :key="index"
          >
            <span
              @click="
                !item.children
                  ? $router.push(item.url)
                  : (item.open = !item.open)
              "
            >
              <div
                class="item py-1 ps-3 pe-3 d-flex justify-content-between align-items-center"
                :class="$router.currentRoute.path == item.url ? 'active' : ''"
              >
                <v-icon
                  v-if="item.children"
                  small
                  class="ps-1 mt-3"
                  style="position: absolute; left: 10px; top: 8px"
                  :class="item.open ? 'icon-rotate' : ''"
                  >mdi-chevron-down</v-icon
                >
                <div class="d-flex align-center">
                  <v-icon class="pe-4">{{ item.icon }}</v-icon>
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </span>
            <Transition name="fade" mode="out-in">
              <div
                v-if="item.children && item.open"
                class="d-flex flex-column dropdown"
              >
                <div
                  class="item ps-3 d-flex align-items-center"
                  :class="
                    $router.currentRoute.path == item2.url ? 'active' : ''
                  "
                  v-for="(item2, index2) in item.children"
                  @click="$router.push(item2.url)"
                  :key="index2"
                >
                  <div>
                    <v-icon class="me-3">{{ item2.icon }}</v-icon>
                    <span class="mt-2">{{ item2.name }}</span>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="menu-items pa-0" @click="logoutDialog = true">
            <div
              class="py-1 ps-3 pe-3 d-flex justify-content-start align-items-center"
            >
              <span class="ms-2">خروج</span>
              <v-icon class="pe-4 ms-4">$Logout</v-icon>
            </div>
          </div>
        </div>
      </v-navigation-drawer>
    </div>
    <div class="menu d-none d-sm-none d-md-block">
      <v-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <div class="logo-image-navbar">
          <img src="../assets/images/logoname.png" />
        </div>
      </v-col>
      <div class="menu-box ps-2 pe-2 mt-3">
        <div class="menu-items pa-0" v-for="(item, index) in nav" :key="index">
          <span
            @click="
              !item.children ? $router.push(item.url) : (item.open = !item.open)
            "
          >
            <div
              class="py-1 ps-3 pe-3 d-flex justify-content-end align-items-center"
              :class="$router.currentRoute.path == item.url ? 'active' : ''"
            >
              <v-icon
                v-if="item.children"
                small
                class="ps-1"
                style="position: absolute; left: 15px; top: 15px"
                :class="item.open ? 'icon-rotate' : ''"
                >mdi-chevron-down</v-icon
              >
              <span>{{ item.name }}</span>
              <v-icon class="pe-4">{{ item.icon }}</v-icon>
            </div>
          </span>
          <Transition name="fade" mode="out-in">
            <div
              v-if="item.children && item.open"
              class="d-flex flex-column dropdown"
            >
              <div
                class="py-1 ps-3 pe-3 my-1 d-flex justify-content-end align-items-center"
                :class="$router.currentRoute.path == item2.url ? 'active' : ''"
                v-for="(item2, index2) in item.children"
                @click="$router.push(item2.url)"
                :key="index2"
              >
                <span>{{ item2.name }}</span>
                <v-icon class="pe-2">{{ item2.icon }}</v-icon>
              </div>
            </div>
          </Transition>
        </div>
        <v-divider class="my-2"></v-divider>
        <div class="menu-items pa-0" @click="logoutDialog = true">
          <div
            class="py-1 ps-3 pe-3 d-flex justify-content-end align-items-center mb-16"
          >
            <span>خروج</span>
            <v-icon class="pe-4">$Logout</v-icon>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="app-body">
        <main class="main mt-10 mt-lg-0">
          <div class="container-fluid pe-sm-5 pe-3 ps-sm-5 ps-3">
            <router-view></router-view>
          </div>
        </main>
      </div>
      <!-- footer-for-desctop -->
      <div
        class="main-footer flex-md-row justify-space-between d-none d-sm-none d-md-flex mt-0"
      >
        <div class="mainFont--text">
          کلیه حقوق این سایت متعلق به مجموعه کتاب‌ باز است.
        </div>
        <div class="mainFont--text">
          نسخه:
          <a
            :href="'/ChangeLog'"
            target="_blank"
            class="font-weight-bold shopPrimary--text"
          >
            {{ version }}
          </a>
        </div>
        <div>
          <span class="mainFont--text pe-1">طراحی، توسعه و اجرا:</span>
          <a
            class="font-weight-bold shopPrimary--text"
            href="https://sarmadbs.com/"
            target="blank"
            >خدمات تجارت سرمد</a
          >
        </div>
      </div>
      <!-- footer-for-mobile -->
      <div
        class="main-footer justify-space-between d-sm-flex d-md-none flex-column"
      >
        <div class="mainFont--text">
          کلیه حقوق این سایت متعلق به مجموعه کتاب باز است.
        </div>
        <div class="mainFont--text">
          نسخه:
          <a
            :href="'/ChangeLog'"
            target="_blank"
            class="font-weight-bold shopPrimary--text"
          >
            {{ version }}
          </a>
        </div>

        <div class="mt-2">
          <span class="mainFont--text pe-1">طراحی، توسعه و اجرا:</span>
          <a
            class="font-weight-bold shopPrimary--text"
            href="https://sarmadbs.com/"
            target="blank"
            >خدمات تجارت سرمد</a
          >
        </div>
      </div>
    </div>
    <v-dialog width="450" v-model="logoutDialog">
      <v-card class="pa-4 pb-0 logout-dialog-card">
        <v-card-title class="grey--text text--darken-2">
          <span class="mx-auto" style="font-size: 1.05rem">
            آیا از خروج خود اطمینان دارید؟</span
          >
        </v-card-title>
        <v-card-text>
          <div class="text-center mt-8">
            <v-btn @click="logout()" width="100" class="mx-2 green-mainBtn"
              >بله</v-btn
            >
            <v-btn
              @click="logoutDialog = false"
              width="100"
              class="mx-2 red-mainBtn"
              >خیر</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import nav from "@/_nav";
import moment from "moment-jalaali";
import { version } from "../../package.json";
import Axios from "axios";

export default {
  name: "DefaultContainer",

  data() {
    return {
      version: "",
      nav: [],
      moment: moment,
      logoutDialog: false,
      user: "",
      role: "",
      roles: {
        Manager: "مدیر",
        shop: "مسئول فروشگاه",
        sales: "فروشنده",
      },
      roleName: "",
      allowRender: false,
      dialog: false,
      drawer: false,
    };
  },
  methods: {
    toggle() {
      this.drawer = !this.drawer;
    },
    enToFaDigits(input) {
      if (input == undefined) return;
      var returnModel = "",
        symbolMap = {
          1: "۱",
          2: "۲",
          3: "۳",
          4: "۴",
          5: "۵",
          6: "۶",
          7: "۷",
          8: "۸",
          9: "۹",
          0: "۰",
        };
      input = input.toString();
      for (var i = 0; i < input.length; i++)
        if (symbolMap[input[i]]) returnModel += symbolMap[input[i]];
        else returnModel += input[i];
      return returnModel;
    },
    logout() {
      window.localStorage.clear();
      window.location.replace("/login");
    },
    checkToken() {
      this.dialog = true;
      Axios.post(
        this.baseUrl + "/satrapp/user/checkToken",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allowRender = true;
            this.dialog = false;
          }
        })
        .catch((err) => {
          if (err.response.status == 403 || err.response.status == 404) {
            const title = (
              <div>
                <h3 class="text-center">دسترسی منقضی شده است</h3>
                <span>لطفا جهت استفاده از سامانه، دوباره ورود کنید</span>
              </div>
            );
            this.toast(title, "error");
            localStorage.clear();
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
          }
        });
    },
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  mounted() {
    this.version = version;
    this.roleName = window.localStorage.getItem("role");
    if (
      !window.localStorage.getItem("token") ||
      !window.localStorage.getItem("role")
    ) {
      this.$router.push({
        path: "/",
        query: { return: window.location.pathname },
      });
    } else {
      this.checkToken();
      // if (router.currentRoute.path == "/dashboard") {
      //   if (this.roleName == "secretary") router.push("/secretary/dashboard");
      //   else router.push("/trade/dashboard");
      // }
    }

    this.user = window.localStorage.name;
    this.nav = nav[this.roleName];
    try {
      if (this.roles[this.roleName]) {
        this.role = this.roles[this.roleName];
      } else {
        this.role = "تعریف نشده";
      }
    } catch (error) {
      this.role = "تعریف نشده";
    }
  },
};
</script>
<style lang="scss">
@import "./../assets/scss/variables";
.app {
  padding-top: 0;
  position: relative;
  .app-body {
    min-height: calc(100vh - 61px);
    margin-top: 35px !important;
    @media screen and (min-width: 1300px) {
      float: left;
      width: calc(100vw - 260px) !important;
      margin-top: 15px !important;
    }
  }
  .main-footer {
    width: calc(100vw - 260px) !important;
    height: 61px;
    padding: 20px 25px;
    margin-top: 0 !important;
    background-color: #fff;
    float: left;

    // margin-top: 50px;

    @media only screen and (max-width: 960px) {
      height: 85px;
      text-align: center;
    }
    @media only screen and (max-width: 1300px) {
      width: 100vw !important;
      height: 110px !important;
      text-align: center;
    }
  }
  .menu {
    position: fixed;
    right: 0px;
    top: 0px;
    width: 260px;
    height: 100vh;
    border-right: 1px solid #adb1c25f;
    background-color: #fff;
    padding: 10px;
    z-index: 100;
    direction: ltr;

    .logo-image-navbar {
      display: flex;
      justify-content: center;
      align-self: center;
      width: 100%;
      height: 100%;
      img {
        width: 80px;
        height: auto;
      }
    }

    &-box {
      max-height: 81vh;
      overflow-y: auto;

      &::-webkit-scrollbar {
        direction: rtl;
        width: 6px;
      }

      .v-input__icon.v-input__icon--prepend-inner {
        margin-left: 5px !important;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: unset;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        border-radius: 1px;
        background: #808080c3;
      }
    }

    &-items {
      max-height: 250px;
      position: relative;
      div {
        width: 100%;
        display: flex;
        justify-content: start;
        font-size: 0.86rem;
        margin: 6px 0;
        cursor: pointer;
        border-radius: 12px;
        color: $mainFont;
        path,
        circle {
          stroke: $mainFont;
        }

        &.active {
          background-color: #f4f4ff;
          color: $primary;
          path,
          circle {
            stroke: $primary;
          }
        }
        &:hover {
          background-color: #f4f4ff;
          color: $primary;
          path,
          circle {
            stroke: $primary;
          }
          i {
            color: $primary;
          }
        }
      }
    }
    .dropdown {
      background: rgb(230, 223, 217);
      background: linear-gradient(
        45deg,
        rgb(235, 213, 191) 35%,
        rgb(245, 244, 243) 100%
      );
      padding: 3px 20px !important;
      border-radius: 12px;
      height: fit-content;
    }
  }
  .menu-responsive {
    .logo-image-navbar {
      display: flex;
      justify-content: center;
      align-self: center;
      width: 100%;
      height: 100%;
      img {
        width: 60px;
        height: auto;
      }
    }
    .dropdown {
      background: white;
      background: linear-gradient(45deg, white, white 100%);
      padding: 3px 20px !important;
      border-radius: 12px;
      height: fit-content;
    }
  }
  .icon-rotate {
    transform: rotate(180deg);
    margin-right: 3px;
    margin-top: -3px;
  }
  .main {
    width: calc(100vw - 260px) !important;
    height: 100%;
    padding-top: 15px;
    @media only screen and (max-width: 960px) {
      width: 100% !important;
      padding-top: 0 !important;
    }
  }
}
.logout-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  background-color: #eae5f0 !important;
  .v-card__title {
    background-color: #eae5f0 !important;
  }
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>
